"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (createUi) {
    return function (args) {
        return createUi(require("./TemplateUseCase.html"), args);
    };
});
